import React, { useState } from "react";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

import PaymentMethods from "components/BillingInformation/PaymentMethods";
import RecentBills from "components/BillingInformation/RecentBills";
// import Subscriptions from "components/BillingInformation/Subscriptions/Subscriptions";

import Title from "containers/Title";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  min-height: 500px;

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 75px;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      margin-bottom: 18px;

      @media (max-width: ${breakpoints.mobileM}) {
        flex-direction: column;
        gap: 18px;
        width: 80%;
      }
    `}
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  min-width: 190px;
  height: 52px;
  border: 1px solid #a5aaaf;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #03589c;
  background-color: #ffffff;
  padding: 14px 32px;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  ${({ active }) =>
    active &&
    css`
      color: #ffffff;
      background-color: #03589c;
    `}
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      width: 100%;
      height: 40px;
      padding: 10px 14px;
      font-size: 12px;

      @media (max-width: ${breakpoints.mobileM}) {
        border-radius: 4px;
      }
    `}
`;

const StyledTitle = styled(Title)`
  @media (max-width: ${breakpoints.mobileM}) {
    font-size: 18px;
  }
`;

function BillingInformation() {
  const [selectedTab, setSelectedTab] = useState("recent");

  return (
    <Container>
      <StyledTitle>Billing Information</StyledTitle>
      <Buttons>
        <Button active={selectedTab === "recent"} onClick={() => setSelectedTab("recent")}>
          Recent Bills
        </Button>
        <Button active={selectedTab === "payment"} onClick={() => setSelectedTab("payment")}>
          Payment Methods
        </Button>
      </Buttons>
      {(() => {
        switch (selectedTab) {
          case "recent":
            return <RecentBills />;
          case "payment":
            return <PaymentMethods />;
          default:
            return null;
        }
      })()}
    </Container>
  );
}

export default BillingInformation;
